import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export function TopBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate('/');
  };

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <Link
            to="/"
            className="flex items-center gap-3 min-w-0 text-slate-900 no-underline"
            onClick={() => setMenuOpen(false)}
          >
            <img
              src="/atm.svg"
              alt="Atomberg"
              className="h-7 sm:h-9 w-auto"
              width={160}
              height={50}
            />
            <span className="hidden sm:inline text-sm text-slate-500 border-l border-slate-200 pl-3">
              Fan Cost Calculator
            </span>
          </Link>

          {user && (
            <>
              <nav className="hidden md:flex items-center gap-3 text-sm">
                <NavLink
                  to="/admin/rates"
                  className={({ isActive }) =>
                    `px-3 py-1.5 rounded-md ${isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:text-slate-900'}`
                  }
                >
                  Rates
                </NavLink>
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) =>
                    `px-3 py-1.5 rounded-md ${isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:text-slate-900'}`
                  }
                >
                  Users
                </NavLink>
                <span className="text-slate-400">|</span>
                <span className="text-slate-500 whitespace-nowrap">
                  <span className="font-medium text-slate-700">{user.username}</span>
                </span>
                <button
                  onClick={handleLogout}
                  className="px-3 py-1.5 rounded-md border border-slate-300 hover:bg-slate-50"
                >
                  Log out
                </button>
              </nav>

              <button
                type="button"
                aria-label="Open admin menu"
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((v) => !v)}
                className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-md border border-slate-300 text-slate-700"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  {menuOpen ? (
                    <path d="M6 6l12 12M6 18L18 6" />
                  ) : (
                    <path d="M4 7h16M4 12h16M4 17h16" />
                  )}
                </svg>
              </button>
            </>
          )}
        </div>

        {menuOpen && user && (
          <div className="md:hidden mt-3 border-t border-slate-100 pt-3 flex flex-col gap-1 text-sm">
            <div className="px-1 pb-2 text-xs text-slate-500">
              Signed in as <span className="font-medium text-slate-700">{user.username}</span>
            </div>
            <NavLink
              to="/admin/rates"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `px-3 py-3 rounded-md ${isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-700 hover:bg-slate-50'}`
              }
            >
              Rates
            </NavLink>
            <NavLink
              to="/admin/users"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `px-3 py-3 rounded-md ${isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-700 hover:bg-slate-50'}`
              }
            >
              Users
            </NavLink>
            <button
              onClick={handleLogout}
              className="mt-1 px-3 py-3 rounded-md border border-slate-300 text-left text-slate-700 hover:bg-slate-50"
            >
              Log out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
